import type { PDCFailedSensorReportSchema } from "../types";
import {
    createDateColumn,
    createStringColumn,
    getMetadataValue,
    normalizeStringArray,
} from "./columnHelpers";
import { createLinkColumn } from "./linkColumnHelper";

const namespace = "pdc_failed_sensor_reports";

const getFailedSensorUnitsField = (row: PDCFailedSensorReportSchema, key: string): string => {
    const units = getMetadataValue(row, "Units");
    if (!Array.isArray(units) || units.length === 0) return normalizeStringArray();
    const firstUnit = units[0] as Record<string, string[] | string | undefined> | undefined;
    if (!firstUnit) return normalizeStringArray();
    return normalizeStringArray(firstUnit[key]);
};

export const pdcFailedSensorColumns = [
    createStringColumn<PDCFailedSensorReportSchema>({
        namespace,
        field: "ReportNumber",
        header: "Report Number",
    }),
    createStringColumn<PDCFailedSensorReportSchema>({
        namespace,
        field: "Units.CustomerName",
        header: "Customer Name",
        accessor: (row) => getFailedSensorUnitsField(row, "CustomerName"),
    }),
    createDateColumn<PDCFailedSensorReportSchema>({
        namespace,
        field: "CreatedDate",
        header: "Created Date",
    }),
    createDateColumn<PDCFailedSensorReportSchema>({
        namespace,
        field: "DistributionDate",
        header: "Report Date",
    }),

    createStringColumn<PDCFailedSensorReportSchema>({
        namespace,
        field: "TurbineFrame",
        header: "Turbine Frame",
        accessor: (row) =>
            normalizeStringArray(
                getMetadataValue(row, "TurbineFrame") as string[] | string | undefined,
            ),
    }),
    createStringColumn<PDCFailedSensorReportSchema>({
        namespace,
        field: "AEIC",
        header: "AEIC",
    }),
    createStringColumn<PDCFailedSensorReportSchema>({
        namespace,
        field: "Units.TurbineShopOrderNumber",
        header: "Shop Order Number",
        accessor: (row) => getFailedSensorUnitsField(row, "TurbineShopOrderNumber"),
    }),
    createStringColumn<PDCFailedSensorReportSchema>({
        namespace,
        field: "ReportType",
        header: "Report Type",
    }),
    createLinkColumn<PDCFailedSensorReportSchema>({
        namespace,
        field: "url",
        header: "Source",
    }),
];
